import Endpoint from '../const/endpoint';
import HttpService from '~/zf/frontend/common/http/HttpService';
import VcomProvider from '../../../../../VcomProvider';
import Mode from '../../../../../shared/viiu/componentMuting/const/Mode';
async function loadAutoClose() {
    const { data } = await HttpService
        .get(Endpoint.LOAD_AUTOCLOSE, {
        params: {
            systemId: VcomProvider.adminSystemId,
        },
    });
    return data;
}
async function saveAutoClose(configurations) {
    await HttpService.post(Endpoint.SAVE_AUTOCLOSE, {
        systemId: VcomProvider.adminSystemId,
        configurations,
    });
}
function getSystemId() {
    return Number(VcomProvider.adminSystemId);
}
async function loadComponentMuting() {
    const { data } = await HttpService.get(Endpoint.LOAD_COMPONENT_MUTING, {
        params: {
            systemId: getSystemId(),
        },
    });
    return data;
}
async function createComponentMuting(config) {
    await HttpService.post(Endpoint.CREATE_COMPONENT_MUTING, {
        ...config,
    });
}
async function loadComponentMutingById(id) {
    const { data } = await HttpService.get(Endpoint.LOAD_COMPONENT_MUTING_BY_ID, {
        params: {
            systemId: getSystemId(),
            id,
        },
    });
    data.start = new Date(data.start);
    data.end = new Date(data.end);
    return data;
}
async function updateComponentMuting(config) {
    await HttpService.post(Endpoint.UPDATE_COMPONENT_MUTING, {
        ...config,
    });
}
async function resumeComponentMuting(config) {
    await HttpService.post(Endpoint.RESUME_COMPONENT_MUTING, {
        ...config,
    });
}
async function deleteComponentMuting(id) {
    await HttpService.post(Endpoint.DELETE_COMPONENT_MUTING, { id, systemId: getSystemId() });
}
async function addAlarmsPortletWhenNotAvailable() {
    await HttpService.post(Endpoint.ADD_ALARMS_PORTLET_WHEN_NOT_AVAILABLE, {
        systemId: getSystemId(),
    });
}
async function run(config, mode) {
    if (mode === Mode.CREATE || mode === Mode.SCHEDULE) {
        await createComponentMuting(config);
    }
    else if (mode === Mode.EDIT)
        await updateComponentMuting(config);
    else
        await resumeComponentMuting(config);
}
async function loadComponentFilterOptions() {
    const { data } = await HttpService.get(Endpoint.LOAD_FILTER_OPTIONS, { params: { systemId: getSystemId() } });
    return data;
}
const ApiService = {
    saveAutoClose,
    loadAutoClose,
    loadComponentMuting,
    loadComponentMutingById,
    deleteComponentMuting,
    run,
    addAlarmsPortletWhenNotAvailable,
    getSystemId,
    loadComponentFilterOptions,
};
export default ApiService;
